import Crud from '../components/CheckList/Crud.vue'
import Add from '../components/CheckList/Add.vue'
import Edit from '../components/CheckList/Edit.vue'
import Plan from '../components/CheckList/Plan.vue';
import Executed from '../components/CheckList/Executed.vue';
import ViewExecuted from '../components/CheckList/ViewExecuted.vue';

let routes = {
    path: '/checklists',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/checklists',
            name: 'Check-List',
            component: Crud
        },
        {
            path: '/checklists/add',
            name: 'Novo Check-List',
            component: Add
        },
        {
            path: '/checklists/edit/:id',
            name: 'Editar Check-List',
            component: Edit
        },
        {
            path: '/checklist-planning',
            name: 'Planejamento Check-List',
            component: Plan
        },
        {
            path: '/checklists-executed',
            name: 'Check-Lists Executados',
            component: Executed
        },
        {
            path: '/checklists-executed/view/:id',
            name: 'Visualizar Check-List Executado',
            component: ViewExecuted
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/checkList.js